import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { AsmComponentService, CustomerEmulationComponent } from '@spartacus/asm/components'
import { AsmAuthStorageService } from '@spartacus/asm/root'
import { AuthActions, User, WindowRef } from '@spartacus/core'
import { UserAccountService } from '@spartacus/user/account/core'
import { Observable } from 'rxjs'
import { EbAuthStatePersistenceService } from '../../../auth/services/eb-auth-state-persistence.service'
import { EbUserIdService } from '../../../auth/services/eb-user-id.service'
import { EbUserAccountService } from '../../../user/services/eb-user-account.service'
import { EbCsagentAuthService } from '../../services/eb-csagent-auth.service'

@Component({
    selector: 'eb-customer-emulation',
    templateUrl: './eb-customer-emulation.component.html',
    styleUrls: ['./eb-customer-emulation.component.scss'],
    standalone: false
})
export class EbCustomerEmulationComponent extends CustomerEmulationComponent {
  customer$: Observable<User> = this.userAccountService.getEbActiveUserData()

  constructor(
    protected csagentAuthService: EbCsagentAuthService,
    protected asmComponentService: AsmComponentService,
    protected userService: UserAccountService,
    protected userAccountService: EbUserAccountService,
    public userIdService: EbUserIdService,
    protected router: Router,
    protected store: Store,
    protected authStatePersistenceService: EbAuthStatePersistenceService,
    protected authStorageService: AsmAuthStorageService,
    protected winRef: WindowRef
  ) {
    super(asmComponentService, userService)
  }

  ngOnInit() {
    this.isCustomerEmulationSessionInProgress$ =
      this.asmComponentService.isCustomerEmulationSessionInProgress()
  }

  logoutCustomer() {
    this.csagentAuthService.logoutAsmCustomer().subscribe(() => {
      this.authStorageService.clearEmulatedUserToken()
      this.authStatePersistenceService.asmCustomerLogout()
      this.store.dispatch(new AuthActions.Logout())
    })
  }

  isEndSessionButtonVisible(): boolean {
    return !this.winRef.nativeWindow.localStorage.getItem('emulatedUserToken')
  }
}
